<template>
  <div>
    <ParagraphBody
      weight="bold"
    >
      Here are the capabilities you get:
    </ParagraphBody>
    <GridAuto
      :hasGap="false"
      minWidth="25rem"
    >
      <ParagraphBody
        v-for="item in capabilities"
        :key="item.label"
        :class="$style.capability"
        :hasMargin="false"
      >
        <Icon
          v-if="item.included"
          :class="$style.included"
          icon="checkmarkCircle"
          inline
          :scale="1.5"
        />
        <Icon
          v-else
          :class="$style.excluded"
          icon="closeCircle"
          inline
          :scale="1.5"
        />
        <span>
          {{ item.label }}
        </span>
      </ParagraphBody>
    </GridAuto>
  </div>
</template>

<script>
import {
  GridAuto,
  Icon,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'CapabilitiesList',

  components: {
    GridAuto,
    Icon,
    ParagraphBody,
  },

  props: {
    capabilities: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style module scoped>
.capability.capability {
  margin-bottom: var(--jc-spacer-small);
}

.included {
  color: var(--jcSuccess900);
}

.excluded {
  color: var(--jcError900);
}
</style>
